import { useEffect, useRef, useState } from "react";

/**
 * Full-bleed ambient clip behind the hero copy. Muted, looping, plays inline on mobile.
 * Under prefers-reduced-motion the poster frame is shown instead; if the file is missing or fails
 * to decode the element hides itself so the copy still sits on plain black.
 */
export function HeroVideo({ src, poster, className = "" }: { src: string; poster: string; className?: string }) {
  const ref = useRef<HTMLVideoElement>(null);
  const [failed, setFailed] = useState(false);
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setReduceMotion(media.matches);
    update();
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);

  useEffect(() => {
    const video = ref.current;
    if (!video || reduceMotion || failed) return;
    void video.play().catch(() => { /* autoplay can be blocked; the poster still shows */ });
  }, [reduceMotion, failed]);

  if (failed) return null;
  if (reduceMotion) return <img className={className} src={poster} alt="" aria-hidden="true" />;
  return <video ref={ref} className={className} src={src} poster={poster} muted loop playsInline autoPlay preload="auto" aria-hidden="true" onError={() => setFailed(true)} />;
}
